// extracted by mini-css-extract-plugin
module.exports = {"categories__wrapper":"Q_dp","categories__list":"Q_dq"};